import e from "@dialpad/dialtone-tokens/layered/themes/tokens-109-colors.css?inline";
//#region themes/109.js
var t = { brand: {
	css: e,
	name: "109"
} };
//#endregion
export { t as default };
